export default __webpack_public_path__ + "static/usa-759e8cc0665464d123c92d8c0b0ebe07.jpg";